import { generateEndpoint } from '@ngtrvu/use-api';
import { createApiCall } from 'lib/base';

const GET_USER_LIST = 'GET_USER_LIST';

const apiCall = createApiCall(GET_USER_LIST, (params: {}) => ({
  endpoint: generateEndpoint({
    host: `api/admin/users`,
    params,
  }),
  method: 'GET',
}));

export default apiCall;
